// extracted by mini-css-extract-plugin
export default {"root":"HeaderNavButton_root__TO0K-","business":"HeaderNavButton_business__zcJ-n"};